import { OnInit } from '@angular/core';
import { BulkHttpService } from '../../../../core/bulk';
import { MatStepper, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
var MachineCategoryComponent = /** @class */ (function () {
    function MachineCategoryComponent(http, router, _snackBar) {
        this.http = http;
        this.router = router;
        this._snackBar = _snackBar;
        this.machineType = null;
        this.selStatus = null;
        this.stageStatuses = [];
        this.machineTypeOptions = [
            { value: '', label: 'N/A' },
            { value: 0, label: 'Production' },
            { value: 1, label: 'Test' }
        ];
        this.statusOptions = [{ value: '', label: 'N/A' }];
    }
    MachineCategoryComponent.prototype.ngOnInit = function () {
        this.getStageStatus();
    };
    MachineCategoryComponent.prototype.getStageStatus = function () {
        var _this = this;
        this.http.getStageStatus()
            .subscribe(function (stageStatuses) {
            _this.stageStatuses = stageStatuses;
            _this.statusOptions = [
                { value: '', label: 'N/A' }
            ].concat(stageStatuses.map(function (stage) { return ({
                value: stage.status,
                label: stage.label
            }); }));
        });
    };
    MachineCategoryComponent.prototype.back = function () {
        this.stepperObj.previous();
    };
    MachineCategoryComponent.prototype.submit = function () {
        var _this = this;
        var machineTypeValue = this.machineType || '';
        var statusValue = this.selStatus || '';
        console.log(machineTypeValue, statusValue);
        var machines = [];
        if (this.mList.length) {
            for (var _i = 0, _a = this.mList; _i < _a.length; _i++) {
                var m = _a[_i];
                machines.push(m.m_id);
            }
        }
        else {
            return;
        }
        var obj = {
            test_machine: machineTypeValue,
            status: statusValue,
            machines: "'" + machines.join("','") + "'"
        };
        this.http.updateMacCategory(obj)
            .subscribe(function (result) {
            _this.showSnackBar('Updated successfully!', 0);
            _this.router.navigate(['group-actions'], { queryParams: { reset: true } });
            _this.stepperObj.reset();
        }, function (error) {
            _this.showSnackBar('Update failed!', 0);
            console.log(error);
        });
    };
    MachineCategoryComponent.prototype.showSnackBar = function (message, duration) {
        var _this = this;
        var snackRef = this._snackBar.open(message, 'close');
        if (duration > 0) {
            setTimeout(function () {
                _this._snackBar.dismiss();
            }, duration);
        }
        snackRef.onAction().subscribe(function () {
            _this._snackBar.dismiss();
        });
    };
    return MachineCategoryComponent;
}());
export { MachineCategoryComponent };
